var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14986 0.854863C6.95486 0.659863 6.63986 0.659863 6.44486 0.854863L3.99986 3.29486L1.55486 0.849863C1.35986 0.654863 1.04486 0.654863 0.849863 0.849863C0.654863 1.04486 0.654863 1.35986 0.849863 1.55486L3.29486 3.99986L0.849863 6.44486C0.654863 6.63986 0.654863 6.95486 0.849863 7.14986C1.04486 7.34486 1.35986 7.34486 1.55486 7.14986L3.99986 4.70486L6.44486 7.14986C6.63986 7.34486 6.95486 7.34486 7.14986 7.14986C7.34486 6.95486 7.34486 6.63986 7.14986 6.44486L4.70486 3.99986L7.14986 1.55486C7.33986 1.36486 7.33986 1.04486 7.14986 0.854863Z",
    fill: "#3AA0B6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.a582f02bb83209d695cf4ef9e7d5d238.svg";
export { ForwardRef as ReactComponent };